import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n";

export default function Difference() {
    const { t } = useLanguage();

    return (
        <section
            id="la-differenza"
            data-testid="difference-section"
            className="relative scroll-mt-20 border-t border-[#1E4266] bg-[#081627]"
        >
            <div className="mx-auto max-w-5xl px-6 py-24 lg:px-10 lg:py-32">
                <Reveal>
                    <p className="mb-10 font-mono text-xs font-medium uppercase tracking-[0.3em] text-[#5B8DEF]">
                        {t.difference.label}
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <p
                        data-testid="difference-statement"
                        className="font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl"
                    >
                        {t.difference.headline}
                    </p>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-8 max-w-3xl text-base leading-relaxed text-[#9AA5B1] sm:text-lg">
                        {t.difference.p1}
                    </p>
                </Reveal>
                <Reveal delay={0.24}>
                    <p className="mt-6 max-w-3xl border-l-2 border-[#5B8DEF] pl-5 text-base font-medium leading-relaxed text-[#C9D8EC] sm:text-lg">
                        {t.difference.p2}
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
